import 'reflect-metadata';
import {Vendor} from '../types';
import {Expose} from 'class-transformer';
import {IsBoolean, IsDate, IsNumber, IsOptional, IsString} from 'class-validator';
import {IVendorDbaEntity} from '../types/Vendor';

export class UpdateVendorDto implements Vendor.UpdateVendorInfo {

  @Expose()
  @IsNumber()
  id: number = 0;

  @Expose()
  @IsString()
  name: string = '';

  @Expose()
  @IsString()
  dirRegNo: string = '';

  @Expose()
  @IsDate()
  dirRegFrom: Date = new Date();

  @Expose()
  @IsDate()
  dirRegTo: Date = new Date();

  @Expose()
  @IsString()
  @IsOptional()
  licNo?: string;

  @Expose()
  @IsString()
  address1: string = '';

  @Expose()
  @IsString()
  address2: string = '';

  @Expose()
  @IsString()
  address3: string = '';

  @Expose()
  @IsString()
  city: string = '';

  @Expose()
  @IsString()
  state: string = '';

  @Expose()
  @IsString()
  zip: string = '';

  @Expose()
  @IsString()
  emailAddress: string = '';

  @Expose()
  @IsBoolean()
  isActive: boolean = false;

  @Expose()
  dbaName: IVendorDbaEntity[] = [];
}

export class Vendors {
  public static Endpoints = {
    BaseRoute: 'vendors'
  }
}